export const STEPS_COUNT = 3;

export enum FORMIK_STATUS {
  INITIALIZING = 'initializing',
  READY = 'ready',
}
